import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { IntakeFormReviewSource } from '@grow-therapy-team/seedling-components';

import { ProviderDrawerState, drawerStateAtom } from '../state';
import { intakeFormReviewSourceAtom, selectedFormTitleAtom } from './state';

export function useOpenClientFormsCallback() {
  const setDrawerState = useSetAtom(drawerStateAtom);
  const setSelectedFormTitle = useSetAtom(selectedFormTitleAtom);
  const setIntakeFormReviewSource = useSetAtom(intakeFormReviewSourceAtom);

  return useCallback(
    (formTitle: string, source: IntakeFormReviewSource) => {
      setIntakeFormReviewSource(source);
      setSelectedFormTitle(formTitle);
      setDrawerState(ProviderDrawerState.CLIENT_FORM_RESPONSE);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
}
